export const ROUTES_PATH = {
  // Auth
  SIGNIN: '/signin',
  SIGN_IN_AS_CUSTOMER: '/admin/sign-in/customer',
  SIGNUP: '/signup',
  FORGOT_PASSWORD: '/forgot-password',
  FORGOT_PASSWORD_RESET: '/password-reset',
  FORGOT_EMAIL: '/forgot-email',
  SIGNUP_SUCCESS: '/signup/success',
  SIGNUP_CONFIRM: '/signup/confirm',
  NEWPASSWORD: '/newPassword',
  CUSTOMER: '/customer/:email',
  ACCOUNT: '/account',
  BILLING: '/billing',
  CONTACT: '/contact',
  CONTACT_US: '/contact-us',
  EFFICIENCY: '/efficiency',
  FAQS: '/faq',
  AUTHORIZEDFAQS: '/faqs',
  PAY: '/pay',
  ACCOUNT_LOOKUP: '/account-lookup',
  SERVICES: '/service',
  AUTHORIZED_SERVICES: '/services',
  SETTINGS: '/settings',
  USAGE: '/usage',
  PORTAL_DASHBOARD: '/portal/dashboard',
  SAVINGS: '/saving',
  AUTHORIZED_SAVINGS: '/savings',
  RESIDENT_RESOURCES: '/resources',

  // main
  DASHBOARD: '/'
}
